"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AllTechnologiesPicker = void 0;
var react_1 = __importStar(require("react"));
var framer_motion_1 = require("framer-motion");
var all_technologies_picker_props_1 = require("./all_technologies_picker_props");
var all_technologies_picker_styles_1 = require("./all_technologies_picker_styles");
var styles_1 = require("@material-ui/core/styles");
var last_1 = __importDefault(require("lodash/last"));
var use_debounced_value_1 = require("../../hooks/use_debounced_value");
var technologies_picker_context_1 = require("../technologies_picker_context");
var classnames_1 = __importDefault(require("classnames"));
var index_1 = require("../../index");
var react_infinite_scroll_component_1 = __importDefault(require("react-infinite-scroll-component"));
var DEFAULT_SPRING_TYPE = {
    type: 'spring',
    damping: 18,
};
var useStyles = styles_1.makeStyles(all_technologies_picker_styles_1.styles);
var TechnologyItem = function (_a) {
    var item = _a.item, _b = _a.selectedItems, selectedItems = _b === void 0 ? [] : _b, onAdd = _a.onAdd, onDelete = _a.onDelete, isMobile = _a.isMobile;
    var classes = useStyles({ isMobile: isMobile });
    var technologies = react_1.useContext(technologies_picker_context_1.TechnologiesPickerContext).technologies;
    var selectedItem = react_1.useMemo(function () { return selectedItems.find(function (_a) {
        var name = _a.name;
        return name === item.name;
    }); }, [selectedItems, item]);
    var onClick = react_1.useCallback(function () {
        if (!selectedItem) {
            onAdd(item.name);
            return;
        }
        onDelete(selectedItem.name);
    }, [selectedItem, onAdd, onDelete]);
    var imgUrl = react_1.useMemo(function () {
        var _a;
        var matchingItem = technologies.find(function (techno) { return techno.name === item.name; });
        if (matchingItem === null || matchingItem === void 0 ? void 0 : matchingItem.handle) {
            return "https://process.filestackapi.com/auto_image/" + ((_a = matchingItem === null || matchingItem === void 0 ? void 0 : matchingItem.handle) !== null && _a !== void 0 ? _a : '4A5N89okRPW50jRcmkuM');
        }
        var handle = last_1.default(matchingItem === null || matchingItem === void 0 ? void 0 : matchingItem.url.split('/'));
        return "https://process.filestackapi.com/auto_image/" + (handle !== null && handle !== void 0 ? handle : '4A5N89okRPW50jRcmkuM');
    }, [item, technologies]);
    return (react_1.default.createElement("button", { className: classes.technologyItem, type: "button", onClick: onClick },
        react_1.default.createElement(index_1.Card, { classes: {
                container: classes.technologyImageContainer,
            } },
            react_1.default.createElement("img", { src: imgUrl, alt: item.name, className: classes.technologyImage }),
            react_1.default.createElement(framer_motion_1.AnimatePresence, null, selectedItem && (react_1.default.createElement(framer_motion_1.motion.div, { key: "selected_item_layer_" + (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.name), className: classes.selectedTechnologyLayer, variants: all_technologies_picker_props_1.SELECTED_ITEM_LAYER_TRANSITIONS_PROPS, initial: "initial", animate: "animate", exit: "exit", transition: DEFAULT_SPRING_TYPE },
                react_1.default.createElement(index_1.Typography, { color: "light", variant: "h3" }, (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.index) + 1))))),
        react_1.default.createElement(index_1.Typography, { variant: "body2", classes: {
                container: classes.typography,
            } }, item.name)));
};
var DISPLAYED_ITEMS = 30;
var AllTechnologiesPicker = function (_a) {
    var selectedItems = _a.selectedItems, onAdd = _a.onAdd, onDelete = _a.onDelete, _b = _a.classes, receivedClasses = _b === void 0 ? {} : _b, isMobile = _a.isMobile, _c = _a.noResultsElement, noResultsElement = _c === void 0 ? null : _c, _d = _a.additionalInformations, additionalInformations = _d === void 0 ? null : _d;
    var classes = useStyles({ classes: receivedClasses, isMobile: isMobile });
    var _e = react_1.useState(), onlySelected = _e[0], setOnlySelected = _e[1];
    var containerRef = react_1.useRef(null);
    var _f = react_1.useState(''), query = _f[0], setQuery = _f[1];
    var debouncedQuery = use_debounced_value_1.useDebouncedValue(query, 200);
    var _g = react_1.useContext(technologies_picker_context_1.TechnologiesPickerContext), technologies = _g.technologies, translations = _g.translations;
    var _h = react_1.useState(DISPLAYED_ITEMS), shownItems = _h[0], setShownItems = _h[1];
    var displayedItems = react_1.useMemo(function () {
        return technologies
            .filter(function (_a) {
            var name = _a.name;
            if (!onlySelected) {
                return true;
            }
            return selectedItems.some(function (_a) {
                var selectedName = _a.name;
                return selectedName === name;
            });
        })
            .filter(function (_a) {
            var name = _a.name, tags = _a.tags;
            return __spreadArray(__spreadArray([], (tags !== null && tags !== void 0 ? tags : [])), [name]).some(function (value) { return value.toLowerCase().includes(debouncedQuery.toLowerCase()); });
        })
            .sort(function (_a, _b) {
            var a = _a.name;
            var b = _b.name;
            return a.localeCompare(b);
        });
    }, [technologies, debouncedQuery, onlySelected]);
    var slicedItems = react_1.useMemo(function () { return displayedItems.slice(0, shownItems); }, [displayedItems, shownItems]);
    var handleTextFieldChange = react_1.useCallback(function (event) { return setQuery(event.target.value); }, []);
    react_1.useEffect(function () {
        var _a = (containerRef === null || containerRef === void 0 ? void 0 : containerRef.current) || {}, width = _a.clientWidth, height = _a.clientHeight;
        if (!width || !height) {
            return;
        }
        var sizes = isMobile ? all_technologies_picker_styles_1.technoCardsSizes['mobile'] : all_technologies_picker_styles_1.technoCardsSizes['other'];
        var itemsPerRow = Math.floor(width / sizes.width);
        var rowsCount = Math.floor(height / sizes.height);
        var itemsCount = Math.round(itemsPerRow * rowsCount);
        console.log({ width: width, height: height, itemsPerRow: itemsPerRow, rowsCount: rowsCount, itemsCount: itemsCount });
        setShownItems(itemsCount);
    }, [containerRef.current]);
    var toggleOtherPerk = react_1.useCallback(function () {
        setOnlySelected(!onlySelected);
    }, [onlySelected]);
    return (react_1.default.createElement("div", { className: classes.container, ref: containerRef },
        react_1.default.createElement(index_1.TextField, { classes: {
                container: classes.textField,
            }, fullWidth: isMobile, variant: "flat", value: query, onChange: handleTextFieldChange, placeholder: "Mobile, Javascript, etc..." }),
        isMobile && additionalInformations,
        isMobile && (react_1.default.createElement("button", { className: classnames_1.default(classes.checkboxButton), type: "button", onClick: toggleOtherPerk },
            react_1.default.createElement(index_1.Checkbox, { className: classes.checkbox, variant: "outlined", color: "secondary", checked: !!onlySelected, onChange: toggleOtherPerk }),
            react_1.default.createElement(index_1.Typography, null, translations.checkboxLabel))),
        !displayedItems.length && noResultsElement,
        react_1.default.createElement("div", { id: "allTechnologiesPicker", className: classes.technologiesListWrapper },
            react_1.default.createElement(react_infinite_scroll_component_1.default, { className: classes.technologiesList, dataLength: slicedItems.length, next: function () {
                    setShownItems(shownItems + DISPLAYED_ITEMS);
                }, hasMore: displayedItems.length > shownItems, loader: null, scrollableTarget: "allTechnologiesPicker" }, slicedItems.map(function (item, index) { return (react_1.default.createElement(TechnologyItem, { key: "technology_" + item.name + "_" + index, selectedItems: selectedItems, item: item, onAdd: onAdd, onDelete: onDelete, isMobile: isMobile })); })))));
};
exports.AllTechnologiesPicker = AllTechnologiesPicker;
